import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { getToken } from "../utils/auth";
import "./StudyMaterialDetail.css";
import "quill/dist/quill.snow.css";

const API_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

const StudyMaterialDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [material, setMaterial] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const response = await fetch(`${API_URL}/api/study-material/getAll`, {
          headers: { Authorization: `Bearer ${getToken()}` }
        });
        const result = await response.json();

        // Access the array from result.data based on your JSON structure
        if (result.success && Array.isArray(result.data)) {
          const selected = result.data.find((item) => item._id === id);
          if (selected) {
            setMaterial(selected);
          } else {  
            swal("Error", "Material not found", "error");
            navigate("/");
          }
        }
      } catch (err) {
        console.error("Fetch Error:", err);
        swal("Error", "Failed to load content", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
  }, [id, navigate]);

  if (loading) return <div className="loader">Loading content...</div>;
  if (!material) return <div className="loader">No material found.</div>;

  return (
    <div className="detail-container">
      <button className="back-btn" onClick={() => navigate("/view-all-material")}>
        ← Back to Courses
      </button>

      <header className="detail-header">
        <h1>{material.course}</h1>
        <p className="meta-info">
          Last Updated: {new Date(material.updatedAt).toLocaleDateString()}
        </p>
      </header>

      <hr />

      {/* IMPORTANT: 
          1. 'ql-snow' wrapper ensures Quill styles are applied.
          2. 'ql-editor' is the specific class Quill uses for its content.
      */}
      <div className="content-area ql-snow">
        <div 
          className="ql-editor" 
          dangerouslySetInnerHTML={{ __html: material.content }} 
        />
      </div>
    </div>
  );
};

export default StudyMaterialDetail;